import { render, staticRenderFns } from "./SingleTranscriptQueueAOR.vue?vue&type=template&id=64484eec&"
import script from "./SingleTranscriptQueueAOR.vue?vue&type=script&lang=js&"
export * from "./SingleTranscriptQueueAOR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports